import Link from 'next/link';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import type { DocsCardProps } from './docsCard.types';
import s from './../chiefDoctorCard/chiefDoctorCard.module.scss';

export const DocsCard = ({ title, icon }: DocsCardProps) => {

  return (
    <div className={s.card}>
      <div>
        {icon}
        <h3 className={s.cardTitleSurname}>{title}</h3>
        <p className={s.cardText}>
          Все официальные документы, лицензии
          и сертификаты доступны здесь
        </p>
      </div>
      <div className={s.buttonsContainer}>
        <Link href={'/patients'} className={s.btn}>
          <ActionButton isDivElement>Перейти</ActionButton>
        </Link>
      </div>
    </div>
  );
};
